module.exports = __webpack_public_path__ + "img/wheat.png";